import { CheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/core';
import { Observable } from 'rxjs';
import { CreditCard, Payments } from '../../../../cms-components/checkout/components/custom-credit-card/store/credit-card.state';

export abstract class CustomPaymentTypeAdapter extends CheckoutPaymentTypeAdapter {
  /**
   * Abstract method to assign an extra data to the cart.
   * @param userId: User Id
   */
  abstract creditCardList(
    userId: string,
  ): Observable<Payments>;

  abstract getSelectedCreditCard(
    userId: string,
    creditCardDetailId: string,
  ): Observable<CreditCard>;

  abstract setSelectedCreditCard(
    userId: string,
    cartId: string,
    paymentDetailsId: string,
  ): Observable<CreditCard>;

  abstract removeSelectedCreditCard(
    userId: string,
    paymentDetailsId: string,
  ): Observable<CreditCard>;
}
